"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWall = void 0;
var matter_js_1 = require("matter-js");
var BaseWall = /** @class */ (function () {
    function BaseWall(_width, _height, _x, _y, _hidden) {
        this._width = _width;
        this._height = _height;
        this._x = _x;
        this._y = _y;
        this._hidden = _hidden;
        var options = {
            isStatic: true,
            render: {
                opacity: (this._hidden == true ? 0 : 1),
                fillStyle: "#000",
                strokeStyle: "transparent"
            }
        };
        this._matterBody = matter_js_1.Bodies.rectangle(this._x, this._y, this._width, this._height, options);
    }
    Object.defineProperty(BaseWall.prototype, "body", {
        get: function () { return this._matterBody; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseWall.prototype, "x", {
        get: function () { return this.body.position.x; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseWall.prototype, "y", {
        get: function () { return this.body.position.y; },
        enumerable: false,
        configurable: true
    });
    return BaseWall;
}());
exports.BaseWall = BaseWall;
